export default {
  getGenres: state => state.genres,
  getFeelings: state => Object.keys(state.feelings),
  getFeelingsByKey: (state) => (key) => { 
    return state.feelings[key]
  },
  getShowsByGenre: (state) => (value) => {
    let shows = []
    shows.push(...state.database.filter(x => x.genre.includes(value)))
    return shows
  },
  getLocationDesc: (state) => (value) => {
    let location = state.locations.find(x => x.location === value)
    if(location === undefined) {
      return undefined
    }
    return location.desc
  },
  getShowInfo: (state) => (value) => {
    let showInfo = state.showInfo.find(x => x.show === value)
    if(showInfo === undefined) {
      return undefined
    }

    return showInfo.desc
  },
  currentForm: state => state.form,
  getFormByKey: (state) => (key) => {
    return state.form[key]
  },
  database: state => state.database,
  getAboutStatus: state => state.showAbout,
  getActiveLocation: state => state.activeLocation,
  areResults: state => state.resultsFound,
  getTopThree: state => state.topThree,
  getTopPerGenre: state => state.topPerGenre,
  topLocation: state => {
    return state.topThree.length != 0 ? state.topThree[0].cityOrCountry : ''
  }
}